import { type ReactElement } from "react";
import { Text, Button, type ButtonProps } from "@citibox-panel/ui";
import { Row } from "./DemoScaffold";

const BUTTON_VARIANTS: NonNullable<ButtonProps["variant"]>[] = [
  "contained",
  "outlined",
  "text",
];
const BUTTON_COLORS: NonNullable<ButtonProps["color"]>[] = [
  "primary",
  "secondary",
  "error",
  "neutral",
];
const BUTTON_SIZES: NonNullable<ButtonProps["size"]>[] = [
  "small",
  "medium",
  "large",
];

// Inline SVG so the showcase view never imports @mui/* (façade rule, DESIGN.md §8).
function PlusIcon(): ReactElement {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </svg>
  );
}

export function ButtonDemo(): ReactElement {
  return (
    <>
      {BUTTON_VARIANTS.map((variant) => (
        <div key={variant} style={{ marginBottom: 24 }}>
          <Text variant="subtitle2" component="h3" gutterBottom>
            variant: {variant}
          </Text>
          {BUTTON_COLORS.map((color) => (
            <Row key={color}>
              {BUTTON_SIZES.map((size) => (
                <Button key={size} variant={variant} color={color} size={size}>
                  {color} · {size}
                </Button>
              ))}
            </Row>
          ))}
        </div>
      ))}

      <Text variant="subtitle2" component="h3" gutterBottom>
        Estados
      </Text>
      <Row>
        <Button loading>Cargando</Button>
        <Button disabled>Deshabilitado</Button>
        <Button startIcon={<PlusIcon />}>Con icono inicio</Button>
        <Button endIcon={<PlusIcon />} variant="outlined">
          Con icono fin
        </Button>
      </Row>
      <div style={{ maxWidth: 320 }}>
        <Button fullWidth>Ancho completo</Button>
      </div>
    </>
  );
}
